import { mergeAttributes, Node } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    nwDivider: {
      setNWDivider: () => ReturnType;
    };
  }
}

export const NWDividerAdapter = Node.create({
  name: "nw-divider",
  group: "block",
  content: "block*",
  draggable: false,
  selectable: false,

  parseHTML() {
    return [
      {
        tag: "nw-divider",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["nw-divider", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("nw-divider");
      dom.appendChild(node.content.toJSON());
      dom.innerHTML = node.content.size
        ? node.content
            .toJSON()
            .map((child: { text: string }) => child.text)
            .join("")
        : "";
      return { dom };
    };
  },

  addCommands() {
    return {
      setNWDivider:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
          });
        },
    };
  },
});
